function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18",
  height: "18",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#DADCDF",
  cx: "9",
  cy: "9",
  r: "9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.005 6.95a1.169 1.169 0 110 2.338 1.169 1.169 0 010-2.338zm0 .556a.613.613 0 10.001 1.227.613.613 0 000-1.227zM9.01 9.469c-1.138 0-2.06 1.018-2.06 2.267a.278.278 0 10.556 0c0-.945.677-1.711 1.504-1.711.826 0 1.503.766 1.503 1.71a.278.278 0 10.556 0c0-1.248-.922-2.266-2.06-2.266z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.86 5.724L7.737 4.65H4.473a.823.823 0 00-.823.823v7.054c0 .455.368.823.823.823H13.5c.47 0 .85-.38.85-.85V6.575l-.007-.107a.85.85 0 00-.843-.743l-4.64-.001zM4.473 5.35h2.983L8.58 6.425h4.92a.15.15 0 01.15.15V12.5a.15.15 0 01-.15.15H4.473a.123.123 0 01-.123-.123V5.473c0-.068.055-.123.123-.123z",
  fill: "#FFF"
}))));